import { pick } from 'ramda';

const getInitialValues = pick(['name', 'email', 'enabled', 'id']);

export default getInitialValues;
